import { Stack, Card, Text } from "@mantine/core";
import { ReactComponent as KnowledgeIcon } from "../../../assets/icons/knowledge.svg";
import { ReactComponent as OpenIcon } from "../../../assets/icons/open-external.svg";
import SectionTitle from "../../../components/Elements/SectionTitle/SectionTitle";
import CustomCard from "../../../components/Elements/Card/Card";
import Title from "../../../components/Elements/Title/Title";

const KnowledgeBase: React.FC = () => {
  const goToLink = (url: string) => {
    window.open(url, "_blank");
  };

  return (
    <Stack className="w-full" gap="0.5rem">
      <SectionTitle Icon={KnowledgeIcon} title="Knowledge base(s)" />
      <CustomCard className="flex-col">
        <Card.Section
          className="card-section"
          onClick={() => goToLink("externalknowledgebase.url")}
        >
          <Stack gap="1">
            <Title title="Client Knowledge Base" />
            <Text className="!text-neutral-50 !text-sm font-medium">
              externalknowledgebase.url
            </Text>
          </Stack>
          <OpenIcon />
        </Card.Section>
        <Card.Section
          className="card-section"
          onClick={() => goToLink("internalknowledgebase.url")}
        >
          <Stack gap="1">
            <Title title="Internal Knowledge Base" />
            <Text className="!text-neutral-50 !text-sm font-medium">
              internalknowledgebase.url
            </Text>
          </Stack>
          <OpenIcon />
        </Card.Section>
      </CustomCard>
    </Stack>
  );
};

export default KnowledgeBase;
